import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import {useConfiguration, useLocalesMgr} from 'coreHooks';
import {registerModuleStateReset} from 'coreUtils/moduleState';

const providersMap = new Map();

registerModuleStateReset(() => providersMap.clear());

export default () => {
	const {managerRepository} = useGeneralProvider();
	const provider = useConfiguration('sitePreferences.cmsProvider');
	const localesMgr = useLocalesMgr();
	const language = localesMgr.getCurrentLanguage().getLanguageCode();
	const key = provider + language;

	if (!providersMap.has(key)) {
		providersMap.set(key, managerRepository.getCmsProvidersMgr().getProvider(provider));
	}

	return providersMap.get(key);
};